export default {
  uniqueHospitalValue: 'Hospital value is not unique.',
  validatePassword:
    'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character',
};
